import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

function NotAvailable() {
  return (
    <Typography variant="subtitle2" component="span" color="warning">
      <FormattedMessage
        id="SP_MAP_MODAL_NOT_AVAILABLE"
        defaultMessage="Not Available"
      />
    </Typography>
  );
}

export default NotAvailable;
